<template>
  <ModalBuilder.FixedCenter>
    <ModalBuilder.Overlay @click.native="onOverlayClick" />

    <ModalBuilder.Container
      class="relative mt-1 flex max-h-full transform flex-col justify-between overflow-visible rounded-lg bg-white p-5 shadow transition-all md:mb-4 md:mt-8"
      :container-class="containerClass" container-translate-y="" :sizeClass="sizeClass">
      <div class="flex flex-row items-center space-x-4">
        <component :is="icon.name || icon" class="h-6 w-6" :class="icon.class" />
        <h1 class="text-xl" :class="title.class" v-text="title.text || title" />
      </div>
      <hr class="mx-12 my-4" />
      <slot name="body"></slot>

      <slot name="footer">
        <ModalBuilder.Footer v-bind="footer" class="bg-white" />
      </slot>
    </ModalBuilder.Container>
  </ModalBuilder.FixedCenter>
</template>

<script>
import { useComposeModal } from '@colescba/ui';

export default {
  name: 'UncloseableModal',
  mixins: [useComposeModal()],

  props: {
    title: {
      type: [String, Object],
      required: true,
      validator: (value) => typeof value === 'string' || 'text' in value,
    },
    icon: {
      type: Object,
      required: false,
      validator: (value) => 'name' in value,
      default: () => ({
        name: 'OutlineExclamationIcon',
        class: 'text-gay-500',
      }),
    },
    footer: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    containerClass: {
      type: [String, Array, Object],
      required: false,
      default: '',
    },
    sizeClass: {
      type: [String, Array, Object],
      required: false,
      default: '',
    },
  },

  computed: {
    hasFooter() {
      return !('no-footer' in this.$attrs)
    },
  },

  methods: {
    onOverlayClick() {
      if (this.cancelOnEscape) this.cancel()
    },
  },
}
</script>
